import FolderState from "./FolderState";
import {useState} from "react";
import FolderCinTrack from "./folderCinTrack";

export const TrackFolder=()=>{
    const [cinData,setCinData]=useState(null);
    return cinData===null ? <FolderState setCinData={setCinData}/> : <FolderCinTrack cinData={cinData}/>
}